import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import Input from "@/components/atoms/Input";
import Button from "@/components/atoms/Button";
import { useState } from "react";

interface ReasonModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  reason_type: string;
  onSubmitRequest: (reason: string) => void;
}

const ReportModal: React.FC<ReasonModalProps> = ({ isOpen, onOpenChange, reason_type, onSubmitRequest }) => {
  const [reason, setReason] = useState<string>("");
  const message =
  reason_type === 'credit note && amount differences'
    ? 'Could you please let us know the reason of the creating credit note and amount differences?'
    : reason_type === 'credit note'
    ? 'Could you please let us know the reason of the creating credit note?'
    : reason_type === 'amount differences'
    ? 'A difference was detected on the amount of the invoice. Could you please let us know the reason?'
    : 'You are about to decline this invoice. Could you please let us know the reason?';

  const handleSubmitRequest = () => {
    if (reason) {
      onSubmitRequest(reason);
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
          <Dialog.Title className="text-lg font-bold">Why?</Dialog.Title>
          <Dialog.Description className="text-sm text-gray-500 mb-4">
            {message}
          </Dialog.Description>

          
          <Input value={reason} onChange={(e) => {setReason(e.target.value)}} placeholder= "Enter Reason"/>

          <div className="flex justify-end mt-4 space-x-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={handleSubmitRequest} disabled={!reason.trim()}>Submit</Button>
          </div>

          <Dialog.Close asChild>
            <button
              className="absolute top-2 right-2 inline-flex items-center justify-center rounded-full text-gray-500 hover:text-black"
              aria-label="Close"
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ReportModal;